import { makeStyles } from 'tss-react/mui'
import { LegendSize, FlexDirection } from './CustomLegends'

export const useStyles = makeStyles<{
  legendSize?: LegendSize
  flexDirection?: FlexDirection
  legendColor?: string
  isKeyValue?: boolean
  roundedBorder?: boolean
}>()((
  theme,
  { legendSize, flexDirection, legendColor, isKeyValue, roundedBorder }
) => {
  return {
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: flexDirection,
      alignItems: flexDirection === 'row' ? 'center' : 'flex-start',
      gap: theme.spacing(1.5),
      width: '100%',
    },
    legendRoot: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(legendSize === 'small' ? 0.5 : 1),
      height: theme.spacing(2.5),
      ...(isKeyValue
        ? {
            width: '100%',
            gap: theme.spacing(2),
          }
        : {}),
    },
    legendBox: {
      height: theme.spacing(legendSize === 'small' ? 1 : 2),
      width: theme.spacing(legendSize === 'small' ? 1 : 2),
      borderRadius: theme.spacing(0.25),
      background: legendColor,
      boxSizing: 'border-box',
    },
    legendDot: {
      height: theme.spacing(1),
      width: theme.spacing(1),
      borderRadius: '50%',
      background: legendColor,
      boxSizing: 'border-box',
    },
    legendLabel: {
      fontSize: '12px',
      fontWeight: 400,
      color: theme.palette.labraText.description,
      ...(isKeyValue
        ? {
            width: 'calc(100% - 64px)',
          }
        : {}),
    },
    legendValue: {
      fontSize: '14px',
      fontWeight: 400,
      color: theme.palette.labraText.primary,
      ...(isKeyValue
        ? { display: 'flex', justifyContent: 'flex-end', width: '180px' }
        : {}),
    },
    leftContent: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(legendSize === 'small' ? 0.5 : 1),
      height: theme.spacing(3),
      ...(isKeyValue
        ? {
            flex: 1,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            justifyContent: 'flex-start',
          }
        : {}),
    },
    legendValueLight: {
      width: '40%',
      whiteSpace: 'nowrap',
      color: theme.palette.labraText.description,
      fontWeight: 500,
      ...(isKeyValue ? { maxWidth: theme.spacing(13) } : {}),
    },
    legendButton: {
      cursor: 'pointer',
      padding: roundedBorder ? theme.spacing(0.5, 1) : theme.spacing(1, 1.5),
      border: `1px solid ${theme.palette.labraText.primary}`,
      borderRadius: roundedBorder ? theme.spacing(6.25) : theme.spacing(0.5),
      ...(roundedBorder
        ? {
            border: 'none',
            backgroundColor: theme.palette.graphColors.primary,
          }
        : {}),
    },
    labelText: {
      color: theme.palette.labraText.primary,
      fontWeight: 500,
    },
    lowVisibility: {
      border: `1px solid ${theme.palette.dividerV2.main}`,
      ...(roundedBorder
        ? {
            border: 'none',
            backgroundColor: theme.palette.graphColors.secondary,
          }
        : {}),
    },
  }
})
